export default {
  allPicksList(state) {
    return state.allPicksList;
  },
  currentPicks(state) {
    return state.currentPicks;
  },
  nickName(state) {
    return state.currentPicks.nickName;
  },
  picksComplete(state) {
    return state.currentPicks.picksComplete;
  },
};